var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.201,
    height: 30.196,
    viewBox: "0 0 30.201 30.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-823.884 -10704.327)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(823.891 10704.331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.694,82.6A15.1,15.1,0,1,0,80.238,97.511V86.961H76.4V82.6h3.833V79.271c0-3.784,2.254-5.874,5.7-5.874a23.21,23.21,0,0,1,3.379.295v3.715h-1.9a2.182,2.182,0,0,0-2.46,2.358V82.6h4.187l-.669,4.364H84.956v10.55A15.1,15.1,0,0,0,97.694,82.6Z",
    transform: "translate(-67.5 -67.5)",
    fill: "#1877f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.215,152.353l.669-4.364H183.7v-2.832a2.182,2.182,0,0,1,2.46-2.358h1.9v-3.715a23.211,23.211,0,0,0-3.379-.295c-3.449,0-5.7,2.09-5.7,5.874v3.326h-3.833v4.364h3.833V162.9a15.256,15.256,0,0,0,4.718,0V152.35Z",
    transform: "translate(-166.241 -132.892)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fb-icon.be79ee71f0338dd274882db25f738521.svg";
export { ForwardRef as ReactComponent };